/**
 * Internal dependencies
 */
import WMUFx from "./fx";

/**
 * 
 */
class WMUFxExpandCollapse extends WMUFx {

	/**
	 * 
	 */
	static type = 'expand-collapse';

	/**
	 * 
	 */
	constructor( element, args = {} )
	{
		super( element, args );

		this.initState = ( undefined !== args.initState ) ? args.initState : 'collapse';
		this.isCollapsed = false;
		this.isExpanded = false;
		this.initVerticalPadding = 0;
		this.elementInitStyle = {...this.element.style};
		
		this.init();
	}

	/**
	 *  
	 */
	init()
	{
		this.initVerticalPadding = this.getElementVerticalPadding();
		this.element.classList.add( 'fx-expand-collapse' );

		if ( 'collapse' !== this.initState && this.element.offsetHeight > 0 )
		{
			this.isExpanded = true;
			this.element.classList.add( 'fx-expand' );
		}
		else
		{
			this.isCollapsed = true;
			this.applyEndCollapseStyle();
			this.element.classList.add( 'fx-collapse' );
		}

		// this.element.style.overflowY = 'hidden';

		this.onTransitionEnd = this.onTransitionEnd.bind( this );
		this.element.addEventListener( 'transitionend', this.onTransitionEnd );
	}

	/**
	 * 
	 */
	clear()
	{
		if ( this.element )
		{
			this.element.classList.remove( 'fx-collapse', 'fx-expand', 'fx-in-progress' );
			this.element.removeEventListener( 'transitionend', this.onTransitionEnd );
			this.element.style = this.elementInitStyle;
			this.element = null;
		}
	}

	/**
	 * 
	 */
	start( action )
	{
		super.start();

		switch( action )
		{
			case 'collapse':
				this.startCollapse();
			break;

			case 'expand':
				this.startExpand();
			break;
		}
	}

	/**
	 * 
	 */
	stop()
	{
		super.stop();
	}

	/**
	 * 
	 */
	getElementHeight()
	{
		const computedStyle = window.getComputedStyle( this.element );
		const verticalPadding = this.getElementVerticalPadding();
		
		if ( 'border-box' === computedStyle.boxSizing )
		{
			return ( this.isCollapsed ) ? this.element.scrollHeight + this.initVerticalPadding : this.element.scrollHeight;
		}

		return this.element.scrollHeight - verticalPadding;
	}

	/**
	 * 
	 */
	getElementVerticalPadding()
	{
		const computedStyle = window.getComputedStyle( this.element );
		const paddingBottom = parseFloat( computedStyle.paddingBottom.replace( /[^0-9.]+/, '' ) );
		const paddingTop = parseFloat( computedStyle.paddingTop.replace( /[^0-9.]+/, '' ) );
		return Math.round( paddingTop + paddingBottom );
	}

	/**
	 * 
	 */
	startCollapse()
	{
		if ( false === this.isCollapsed )
		{
			const element = this.element;
			const height = this.getElementHeight();
			const transition = element.style.transition;
			
			element.style.transition = '';

			element.style.overflowX = 'hidden';
			element.style.overflowY = 'hidden';
	
			// Next render frame
			requestAnimationFrame( () =>
			{
				element.style.height = height + 'px';
				element.style.paddingTop = null;
				element.style.paddingBottom = null;
				element.style.transition = transition;
	
				// The frame following our changes
				requestAnimationFrame( () =>
				{
					this.applyEndCollapseStyle();
				} );
			} );
	
			this.inProgress = true;
			this.isCollapsed = true;
			this.isExpanded = false;

			this.element.classList.remove( 'fx-expand' );
			this.element.classList.add( 'fx-collapse', 'fx-in-progress' );
		}
	}

	/**
	 * 
	 */
	applyEndCollapseStyle()
	{
		const element = this.element;

		element.style.overflowX = 'hidden';
		element.style.overflowY = 'hidden';

		element.style.height = '0px';
		element.style.paddingTop = '0px';
		element.style.paddingBottom = '0px';
	}

	/**
	 * 
	 */
	startExpand()
	{
		if ( false === this.isExpanded )
		{
			this.element.style.height = this.getElementHeight() + 'px';
			this.element.style.paddingTop = null;
			this.element.style.paddingBottom = null;
	
			this.inProgress = true;
			this.isCollapsed = false;
			this.isExpanded = true;

			this.element.classList.remove( 'fx-collapse' );
			this.element.classList.add( 'fx-expand', 'fx-in-progress' );
		}
	}

	/**
	 * 
	 */
	onTransitionEnd( event )
	{
		if ( true === this.inProgress && 'height' === event.propertyName )
		{
			if ( this.isExpanded )
			{
				this.element.style.height = null;
				this.element.style.overflowX = '';
				this.element.style.overflowY = '';
			}

			this.inProgress = false;
			this.element.classList.remove( 'fx-in-progress' );
		}
	}

}

export default WMUFxExpandCollapse;
